import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { HotelNativeRateConditions } from '@bandido/shared/types/hotels/hotel-reservation-flow';

export function HotelNativeConditions({ groups }: { groups?: HotelNativeRateConditions[] }) {
  const { t } = useTranslation();
  return <>{groups?.map((group, index) => <Box key={index} sx={{ my: 1 }}>
    <Typography variant="caption">{t('hotelSearch.nativeGroup', { index: index + 1, count: group.rooms })}</Typography>
    {group.comments && <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>{group.comments}</Typography>}
    {group.taxes.map((tax, i) => <Typography key={i} variant="body2">
      {tax.description ?? t('hotelSearch.surcharge')} · {tax.currency} {tax.amount} · {t(tax.included === true ? 'hotelSearch.chargeIncluded' : tax.included === false ? 'hotelSearch.chargeExcluded' : 'hotelSearch.chargeUnknown')}
    </Typography>)}
    {group.allTaxesIncluded !== true && <Typography variant="caption">{t(group.allTaxesIncluded === false ? 'hotelSearch.chargeExcluded' : 'hotelSearch.chargeUnknown')}</Typography>}
  </Box>)}</>;
}
